import { render, staticRenderFns } from "./FormPrint.vue?vue&type=template&id=136a7e04&scoped=true"
import script from "./FormPrint.vue?vue&type=script&lang=js"
export * from "./FormPrint.vue?vue&type=script&lang=js"
import style0 from "./FormPrint.vue?vue&type=style&index=0&id=136a7e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a7e04",
  null
  
)

export default component.exports